<!-- 问答 -->
<template>
  <div class="essay">
    <div class="content" v-if="info">
      <div class="title fontSize14">
        <!-- <span class="paper_blue">【{{ quesMap[info.type] }}】</span> -->
        <span>{{ no + 1 }}、</span>
        <span v-html="reformHtml(info.content)"></span>
      </div>
      <div class="txts" v-if="!readOnly">
        <el-input type="textarea" :rows="2" v-model="value" placeholder="请输入" @input="change" :disabled="readOnly">
        </el-input>
      </div>
      <div class="next_last">
        <el-button type="info" size="mini" @click="$emit('lastNext', 'last')" v-if="lastNext">上一题</el-button>
        <el-button type="danger" size="mini" class="ml" @click="$emit('lastNext', 'next')"
          v-if="lastNext">下一题</el-button>
        <el-button type="warning" size="mini" class="ml" @click="$emit('submit', info.id)"
          v-if="value && !readOnly && submit">提交</el-button>
      </div>
      <!-- 解析 -->
      <div class="analysisBox" :class="isOne ? '': 'noMargin bottomBorder'" v-if="readOnly">
        <div class="stjx-title" :class="isOne ? '': 'noLine noPadding'">试题解析</div>
        <!-- <div class="d-flex d-flex-middle">您的答案：{{ value }}</div>
        <div>正确答案：<span v-html="reformHtml(info.answer)"></span></div>
        <div class="stjx">试题解析：<span v-html="reformHtml(info.analysis)"></span></div> -->
        <div>您的答案：<span class="cRed">{{value }}</span></div>
        <div>正确答案：<span class="cGreed" v-html="reformHtml(info.answer)"></span></div>
         <div class="stjx">试题解析：<span class="cGrey" v-html="reformHtml(info.analysis||info.resolve)"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { quesMap } from "@/utils/enum.js";
export default {
  name: "essay",
  props: {
    info: {},
    lastNext: false,
    submit: false,
    readOnly: false,
    value: {
      default: "",
    },
    check: {},
    no: '',
    isOne: false,
  },
  data () {
    return {
      quesMap,
    };
  },
  methods: {
    reformHtml (html) {
      if(!html){
        return html
      }
      return html.replace(/<p.*?>/gi, "").replace(/<\/p.*?>/gi, "");
    },
    change (e) {
      // var data = {
      //   id: this.info.id,
      //   value: this.info.myAnswer,
      // };
      this.$emit("input", e);
    },
  },
};
</script>

<style lang="scss">
.essay {
  padding-left: 12px;

  .paper_blue {
    color: #3677EA;
  }

  .paper_red {
    color: #FF2929;
  }

  .next_last {
    text-align: right;
    // border-bottom: 1px solid #D2D2D2;
    // padding: 50px 0;
  }

  .content {
    .title {
      margin-bottom: 15px;
      line-height: 20px;
    }

    .txts {
      textarea {
        width: 100%;
        border: 1px solid #e1e1e1;
        border-radius: 10px;
        height: 100px;
        line-height: 20px;
        margin-bottom: 15px;
        box-sizing: border-box;
        padding: 5px 10px;
        font-size: 14px;
      }
    }
    .noMargin{
      margin: 0 !important;
      .noLine {
        padding-top:10px !important;
        margin: 0;
        display: none;
      }
    }
    .analysisBox {
      box-sizing: border-box;
      padding: 5px 10px;
      margin: 50px 0 0 0;

      div {
        margin: 20px 0;
      }

      .stjx {
        display: flex;

        span {
          width: 420px;
          display: inline-block;
        }
      }

      .stjx-title {
        text-align: center;
        border-top: 1px solid #D2D2D2;
        padding-top: 30px;
        font-size: 14px;
        color: #E03019;
      }
    }
  }
}
</style>
